<template>
  <li>
    <router-link :to="paymentRouterLinkAction">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <h3 v-if="$userIsAdmin">{{ booking.name }} &ndash; {{ bookingPaymentType }}</h3>
          <h3 v-else>#{{ payment.id | padded('0', 5) }} &ndash; {{ bookingOpportunityName }} &ndash; {{ bookingPaymentType }}</h3>
        </div>
        <div class="col-xs-4 col-sm-2 col-md-2 col-lg-1">
          <p>
            <span v-if="bookingPaymentIsOverdue" class="label label-danger"><i class="fa fa-exclamation-triangle fa-fw"></i> Overdue</span>
            <span v-else-if="bookingPaymentIsUnpaid" class="label label-info">Unpaid</span>
            <span v-else-if="bookingPaymentIsSent" class="label label-info">Sent</span>
            <span v-else-if="bookingPaymentIsOnHold" class="label label-info">On Hold</span>
            <span v-else-if="bookingPaymentIsPaid" class="label label-success"><i class="fa fa-check fa-fw"></i> Paid </span>
          </p>
          <p v-if="bookingPaymentIsPaid">
            <span class="label label-success">{{ payment.transaction.method | humanize }} </span>
          </p>
        </div>
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-2">
          <p v-if="bookingPaymentIsPaid"><i class="fa fa-calendar"></i> Paid On: {{ payment.paid_date | date($user.date_format_preference) }}</p>
          <p v-else-if="bookingPaymentIsSent"><i class="fa fa-calendar"></i> Sent On: {{ payment.sent_date | date($user.date_format_preference) }}</p>
          <p v-else><i class="fa fa-calendar"></i> Due By: {{ payment.due_date | date($user.date_format_preference) }}</p>
        </div>
        <div v-if="$userIsAdmin" class="col-xs-4 col-sm-3 col-md-3 col-lg-2">
          <p>Booking ID: {{ booking.id }}</p>
        </div>
        <div class="col-xs-12 col-sm-3 col-md-3 col-lg-1">
          <span class="price">{{ payment.total_inclusive | currency(booking.currency) }}</span>
        </div>
      </div>
    </router-link>
    <a v-if="canEditPaymentDueDate" href="#" data-toggle="modal" :data-target="dueDateModalId">Edit Due Date</a>
    <booking-edit-payment-due-date-modal v-if="$userIsAdmin" :payment-id="payment.id" :payment-due-date="payment.due_date" location="payments" :update-payment="updatePayment"/>
  </li>
</template>

<script>
import { mapActions } from 'vuex'
import { helpers, paymentHelpers } from 'mixins/bookings'
import BookingEditPaymentDueDateModal from '../booking/BookingEditPaymentDueDateModal'

export default {
  mixins: [helpers, paymentHelpers],

  components: { BookingEditPaymentDueDateModal },

  props: {
    payment: {
      required: true,
      type: Object
    }
  },

  methods: {
    ...mapActions('payment', ['updatePayment'])
  },

  computed: {
    booking () {
      return this.payment.booking
    },

    canEditPaymentDueDate () {
      return this.$userIsBookingRegionalAdmin(this.$user, this.booking)
    },

    dueDateModalId () {
      return '#modal-edit-due-date' + '' + this.payment.id
    },

    paymentRouterLinkAction () {
      const action = this.payment.status === 'paid'
        ? 'view'
        : 'process'

      return { name: 'payments.show', params: { bookingId: this.booking.id, paymentId: this.payment.id, action } }
    }
  }
}
</script>
